
import { api } from "./api";
import { LeagueRunSubmission } from "../league/types";

const QUEUE_KEY = "gsc_league_sync_queue";

interface QueueItem {
    id: string;
    type: "LEAGUE_RUN";
    payload: LeagueRunSubmission;
    timestamp: number;
}

export const syncQueueService = {
    /**
     * Ajoute une soumission à la file d'attente locale.
     */
    enqueue: (payload: LeagueRunSubmission) => {
        const queue = getQueue();
        queue.push({
            id: crypto.randomUUID(),
            type: "LEAGUE_RUN",
            payload,
            timestamp: Date.now()
        });
        saveQueue(queue);
        console.log(`[SYNC] Run enqueued. Total pending: ${queue.length}`);
    },

    /**
     * Tente de vider la file d'attente si le réseau est disponible.
     */
    processQueue: async () => {
        if (!navigator.onLine) return;
        
        const queue = getQueue();
        if (queue.length === 0) return;

        console.log(`[SYNC] Processing ${queue.length} items...`);
        const remaining: QueueItem[] = [];
        let processedCount = 0;

        for (const item of queue) {
            try {
                if (item.type === "LEAGUE_RUN") {
                    // On retente l'envoi
                    const res = await api.post('/league/run', item.payload);
                    
                    if (res.success) {
                        processedCount++;
                    } else if (res.error === "NETWORK_ERROR" || res.error === "Failed to fetch") {
                        // Erreur réseau persistante, on garde
                        remaining.push(item);
                    } else {
                        // Erreur logique (ex: 400 Bad Request), on jette pour ne pas bloquer
                        console.warn("[SYNC] Dropping invalid item:", item.id, res.error);
                    }
                }
            } catch (e) {
                // Crash inattendu, on garde par sécurité
                remaining.push(item);
            }
        }

        saveQueue(remaining);
        if (processedCount > 0) {
            console.log(`[SYNC] Successfully synced ${processedCount} items.`);
        }
    },

    getPendingCount: () => getQueue().length,
    
    initAutoSync: () => {
        if (typeof window !== 'undefined') {
            window.addEventListener('online', () => syncQueueService.processQueue());
            // Tentative périodique toutes les minutes
            setInterval(() => syncQueueService.processQueue(), 60000);
        }
    }
};

function getQueue(): QueueItem[] {
    try {
        return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
    } catch { return []; }
}

function saveQueue(q: QueueItem[]) {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
}
